/**
 * Configuration object for the DocPro application.
 * @typedef {Object} Config
 * @property {string} appName - The name of the application.
 * @property {string} appVersion - The version of the application.
 * @property {string} appUrl - The URL of the application.
 * @property {string} patientServerUrl - The URL of the patient server.
 * @property {string} apiServerUrl - The URL of the API server.
 * @property {string} notificationServerUrl - The URL of the notification server.
 */

function getEnvironmentConfig() {
  let _AppName = "DocPro";
  let _AppPhone = "(669) 272-3868";
  let _AppEmail = "info@doc.pro";
  let _AppAddress = "New York, United States";
  let FileUploadPortal = "https://files.doc.pro";
  let uploadFileSizeLimit = 25; // 25MB
  let notificationPingTime = 3; // 3s
  let acceptUploadFileType = ".jpg, .gif, .png, .pdf, .jpeg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .mp4, .mov, .heif, .webp";
  let deepgramKey = "f6__FOURTEEN__f__FIFTEEN____FOURTEEN__dd__TWELVE__9fd8__FOURTEEN____TEN__bb7__ELEVEN__b8__TEN__87e__THIRTEEN____ELEVEN__c9deee__FIFTEEN____THIRTEEN__8__FOURTEEN__a__TWELVE__d";

  const hostname = window.location.hostname;

  const adminRoutes = [
    "/invitations",
    "/users",
    "/onboard-practice",
    "/feature-configs",
    "/practice-permissions",
    "/role-permissions"
  ];

  let appUrl;
  let patientServerUrl;
  let apiServerUrl;
  let notificationServerUrl;
  let appVersion;
  let partnerServerUrl;
  let paymentServerUrl;
  let SMSCreditQuantity = 1000;
  let LetterCreditQuantity = 1000;
  let IdealSessionLogoutTime = 25; //25 Min
  let workerServerUrl;
  let timeZone = "local";

  switch (hostname) {
    case "app.doc.pro":
      appVersion = "v1.4.22";
      appUrl = "https://app.doc.pro";
      patientServerUrl = "https://patient.aihconweb.com/api/v1";
      apiServerUrl = "https://api.aihconweb.com/api/v1";
      notificationServerUrl = "https://notification.aihconweb.com/api/v1";
      partnerServerUrl = "https://partner.aihconweb.com/api/v1";
      paymentServerUrl = "https://payment.aihconweb.com";
      workerServerUrl = "https://worker.aihconweb.com/api/v1";
      break;
    case "dev.doc.pro":
      appVersion = "dev v1.4.22";
      appUrl = "https://dev.doc.pro";
      patientServerUrl = "https://patient.dev.aihconweb.com/api/v1";
      apiServerUrl = "https://api.dev.aihconweb.com/api/v1";
      notificationServerUrl = "https://notification.dev.aihconweb.com/api/v1";
      partnerServerUrl = "https://partner.dev.aihconweb.com/api/v1";
      paymentServerUrl = "https://payment.dev.aihconweb.com";
      workerServerUrl = "https://worker.dev.aihconweb.com/api/v1";
      break;
    case "local.doc.pro":
      appVersion = "rds v1.4.22";
      appUrl = "https://local.doc.pro";
      // patientServerUrl = "http://local.doc.pro:8001/api/v1";
      // apiServerUrl = "http://local.doc.pro:8002/api/v1";
      patientServerUrl = "https://patient.aihconweb.com/api/v1";
      apiServerUrl = "https://api.aihconweb.com/api/v1";
      notificationServerUrl = "https://notification.aihconweb.com/api/v1";
      partnerServerUrl = "https://partner.aihconweb.com/api/v1";
      paymentServerUrl = "https://payment.dev.aihconweb.com";
      workerServerUrl = "https://worker.dev.aihconweb.com/api/v1";
      break;
    default:
      appVersion = "local v1.4.22";
      appUrl = "http://localhost:3000";
      // patientServerUrl = "http://127.0.0.1:8001/api/v1";
      // apiServerUrl = "http://127.0.0.1:8002/api/v1";
      // notificationServerUrl = "http://127.0.0.1:8005/api/v1";
      // appUrl = "https://dev.doc.pro";
      patientServerUrl = "https://patient.dev.aihconweb.com/api/v1";
      apiServerUrl = "https://api.dev.aihconweb.com/api/v1";
      // patientServerUrl = "http://192.168.68.124:8001/api/v1";
      // apiServerUrl = "http://192.168.68.124:8002/api/v1";
      notificationServerUrl = "https://notification.dev.aihconweb.com/api/v1";
      // notificationServerUrl = "http://192.168.68.124:8005/api/v1";
      partnerServerUrl = "https://partner.dev.aihconweb.com/api/v1";
      // partnerServerUrl = "http://127.0.0.1:8000/api/v1";
      paymentServerUrl = "https://payment.dev.aihconweb.com";
      // paymentServerUrl = "http://192.168.0.112:8010";
      workerServerUrl = "https://worker.dev.aihconweb.com/api/v1";
      // workerServerUrl = "http://192.168.68.124:8007/api/v1";
      break;
  }

  return {
    _AppName,
    _AppEmail,
    _AppPhone,
    _AppAddress,
    appName: _AppName,
    appVersion,
    appUrl,
    patientServerUrl,
    apiServerUrl,
    notificationServerUrl,
    adminRoutes,
    partnerServerUrl,
    paymentServerUrl,
    SMSCreditQuantity,
    LetterCreditQuantity,
    FileUploadPortal,
    uploadFileSizeLimit,
    acceptUploadFileType,
    notificationPingTime,
    deepgramKey,
    workerServerUrl,
    IdealSessionLogoutTime,
    timeZone
  };
}

export const Config = getEnvironmentConfig();
